import pricing from "./pricing.component";
import pricingUrls from "./pricing.urls";
import PricingTransforms from "./pricing.transforms";

const pricingModule = angular
  .module("app.components.pricing", [])
  .component("pricingPage", pricing)
  .service("PricingTransforms", PricingTransforms)
  .config(pricingUrls);

export default pricingModule;



// WEBPACK FOOTER //
// ./src/pages/pricing/pricing.module.js